<script setup lang="ts">
import { EProviders, type MenuProviderType } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'
import { menuAdminView } from '../../router/menuRoutes'

provide<MenuProviderType>(EProviders.MENU, {
    adminAppMenu: menuAdminView,
    adminAppMenuTitle: 'menu.adminHubMenu'
})
</script>

<template>
    <slot />
</template>
